<template>
    <div class="TL_BookSession">
        <h1>Please login</h1>

        <transition name="slide-fade">
            <div class="Form-inputError" v-if="asyncFormError">{{asyncFormError}}</div>
        </transition>

         <transition name="up-fade" appear>
            <login></login>
        </transition>
    </div>
</template>

<script>
    import axios from "axios";
    import { required, email, minValue, sameAs, requiredIf } from 'vuelidate/lib/validators';
    import Login from '../components/tl-login.vue';

    export default {
        components: {
            Login,
        },
        mounted() {},
        props: {},
        methods: {
            validateInput: function(subject) {
                subject.$touch();
            },
            switchVisibility: function(evt) {
                evt.preventDefault();
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
                this.visibilityState = this.visibilityState === 'Show' ? 'Hide' : 'Show';
                this.$refs.password.focus();
            },
            calculateCompletedSubSteps: function(stepValidation, stepDefinition) {
                let vm = this;


                vm.subStep = 0;

                for(var thisStep in stepDefinition) {
                    if(stepValidation[thisStep] && !stepValidation[thisStep].$invalid) {
                        vm.subStep ++;
                    }
                }
            },
            showNextStep: function() {
                let vm = this;

                // Show next step
                if (vm.currentStep < vm.totalSteps){
                    vm.currentStep ++;
                } else {
                    // All steps complete!
                }

                // set subStep after state settles, so number of steps is properly reported for next step
                vm.$nextTick(function() {
                    vm.subStep = 0;
                });
            },
            createFunctionWithTimeout: function(callback, opt_timeout) {
                var called = false;

                function fn() {
                    if (!called) {
                        called = true;
                        callback();
                    }
                }

                setTimeout(fn, opt_timeout || 1000);
                return fn;
            },
            submitStep: function (evt) {
                let vm = this;
                let url = this.baseUrl + "/book-session/step1";
                let postData = {};
                let analyticsAction = '';
                let analyticsEventObject = {
                    event_category: 'engagement',
                    event_label: ''
                };

                evt.preventDefault();
                if (!vm.disableForm) {
                    vm.disableForm = true;

                    if (vm.currentStep == 1) {
                        postData = {
                            'quantity': vm.step1.quantity,
                            'venue': vm.venueId
                        }

                        analyticsAction = 'book_session_progress';
                        analyticsEventObject.event_label = 'Step 1 complete';

                        vm.showNextStep();
                        vm.disableForm = false;
                    } else if (vm.currentStep == 2) {
                        url = this.baseUrl + "/book-session/step2";
                        postData = vm.step2;

                        postData['venue'] = vm.venueId;
                        postData['quantity'] = vm.step1.quantity;

                        for(var thisStep in vm.step2) {
                            postData[thisStep] = vm.step2[thisStep];
                        }

                        analyticsAction = 'sign_up';
                        analyticsEventObject.event_label = 'Step 2 complete';
                        analyticsEventObject.send_to = [
                            'default',
                            'AW-1068953400/YxNKCNyFu4YBELje2_0D'
                        ];

                        // Send data from this registration step to API
                        vm.axiosInstance.post(url, postData)
                            .then(function(response) {
                                if (response.data) {
                                    // reset error
                                    vm.asyncFormError = false;

                                    // Get user id & token from response if in first step
                                    if (vm.currentStep == 2) {
                                        vm.userToken = response.data.data.token;
                                    }

                                    if (window.gtag) {
                                        window.gtag('event', analyticsAction, analyticsEventObject);
                                    }

                                    // Go to next step in registration
                                    vm.showNextStep();
                                    vm.disableForm = false;
                                }
                            }).catch(function(error) {
                                if (error.response && error.response.data && error.response.data.reason) {
                                    vm.asyncFormError = error.response.data.reason;
                                }
                                vm.disableForm = false;
                            });
                    }

                }
            },
            checkedOptIn: function() {
                let vm = this;
                let url = this.baseUrl + "/book-session/optin";
                let postData = {
                    token: vm.userToken,
                    optin: vm.optIn
                };

                // Send data from this registration step to API
                vm.axiosInstance.post(url, postData)
                .then(function(response) {
                        if (response.data) {
                            // reset error
                            vm.asyncFormError = false;

                            let analyticsAction = 'opt_in';
                            let analyticsEventObject = {
                                event_category: 'engagement',
                                event_label: 'Opt in to Ticketlab marketing'
                            };
                            window.gtag('event', analyticsAction, analyticsEventObject);
                        }
                }).catch(function(error) {
                    if (error.response && error.response.data && error.response.data.reason) {
                        vm.asyncFormError = error.response.data.reason;
                    }
                });
            },
            numberInputChanged: function(evt) {
                this.step1.quantity = evt;
            },
            basketUpdatedByProductList: function(basketContents) {
                let vm = this;

                vm.basket = basketContents;
            }
        },
        validations: {
            step1: {
                quantity: {
                    required,
                    minValue: minValue(1),
                },
                terms: {
                    sameAs: sameAs( () => true )
                }
            },
            step2: {
                forename: {
                    required
                },
                surname: {
                    required
                },
                email: {
                    email,
                    requiredIf: requiredIf(function () {
                        return this.step2.phone == ''
                    }),
                },
                phone: {
                    requiredIf: requiredIf(function () {
                        return this.step2.email == ''
                    }),
                },
            }
        },
        data: function () {
            return {
                baseUrl: process.env.VUE_APP_API_URL,
                venueId: process.env.VUE_APP_VENUE_ID,
                axiosInstance: axios.create({
                    baseURL: this.baseUrl,
                }),
                step1: {
                    quantity: 0,
                    terms: false
                },
                step2: {
                    forename: '',
                    surname: '',
                    email: '',
                    phone: '',
                },
                passwordFieldType: 'password',
                visibilityState: 'Show',
                currentStep: 1,
                totalSteps: 3,
                steps: [
                    {
                        name: 'Welcome',
                        subSteps: 2
                    },
                    {
                        name: 'Contact Details',
                        subSteps: 3
                    },
                    {
                        name: 'Thanks',
                        subSteps: 0
                    }
                ],
                subStep: 0,
                asyncFormError: false,
                optIn: false,
                disableForm: false,
                userToken: '',
                basket: [],
            }
        }
    }
</script>
